import { ProgramModel } from '@cibo/core'
import { ProgramIcon, useSelectedFieldsProgramLimit } from '@cibo/programs'
import WarningIcon from '@mui/icons-material/WarningAmberOutlined'
import { Alert, AlertTitle, ListItemButton, ListItemText, Radio, Stack } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export const ProgramOptionItem = ({
  program: { programId, program },
  setProgramId,
  selectedProgramId,
  fieldCount,
}: {
  program: ProgramModel
  setProgramId: Dispatch<SetStateAction<string | undefined>>
  selectedProgramId?: string
  fieldCount?: number
}) => {
  const { t } = useTranslation('impact/EnrollSelectedFields')
  const { isReady, display, limits } = useSelectedFieldsProgramLimit()

  if (isReady && display) {
    return (
      <Alert
        severity="warning"
        icon={
          <Stack spacing={2} direction="row">
            <WarningIcon color="warning" sx={{ mt: '15px', mx: '9px' }} />
            <ProgramIcon program={program} />
          </Stack>
        }
      >
        <AlertTitle color="primary.main" sx={{ pt: '15px' }}>
          {program.content.fields.title}
        </AlertTitle>
        {t('selectedExceedCaps', {
          count: fieldCount,
          context: limits && limits[0].display && limits[0].unit,
        })}
      </Alert>
    )
  }

  return (
    <ListItemButton
      onClick={() => setProgramId(programId)}
      sx={{ height: 64, '&:hover': { cursor: 'pointer' } }}
    >
      <Stack spacing={2} direction="row" alignItems="center">
        <Radio
          data-testid={`enroll_${programId}`}
          checked={selectedProgramId === programId}
          onClick={() => setProgramId(programId)}
        />
        <ProgramIcon program={program} />
        <ListItemText primary={program.content.fields.title} />
      </Stack>
    </ListItemButton>
  )
}
